module.exports = __webpack_public_path__ + "ac7cdf256bca006ed8ab5b01e74e1135.png";